import { render, staticRenderFns } from "./scanCode.vue?vue&type=template&id=1631220c&"
import script from "./scanCode.vue?vue&type=script&lang=js&"
export * from "./scanCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports